import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["authorizeActions", "ssoActions", "ssoLink", "authorizeNotice", "ssoNotice"];

  declare readonly authorizeActionsTarget: HTMLElement;
  declare readonly ssoActionsTarget: HTMLElement;
  declare readonly ssoLinkTarget: HTMLAnchorElement;
  declare readonly authorizeNoticeTarget: HTMLElement;
  declare readonly ssoNoticeTarget: HTMLElement;

  #onOrgChanged = (event: Event) => {
    const { ssoRequired, ssoLoginUrl } = (event as CustomEvent).detail;
    this.#showSso(Boolean(ssoRequired) && Boolean(ssoLoginUrl), ssoLoginUrl);
  };

  connect() {
    window.addEventListener("oauth:org-changed", this.#onOrgChanged);
  }

  disconnect() {
    window.removeEventListener("oauth:org-changed", this.#onOrgChanged);
  }

  #showSso(showSso: boolean, ssoLoginUrl: string | null) {
    if (showSso && ssoLoginUrl) {
      this.ssoLinkTarget.href = ssoLoginUrl;
    }
    this.ssoActionsTarget.classList.toggle("hidden", !showSso);
    this.authorizeActionsTarget.classList.toggle("hidden", showSso);
    this.ssoNoticeTarget.classList.toggle("hidden", !showSso);
    this.authorizeNoticeTarget.classList.toggle("hidden", showSso);
  }
}
